import useEffect from 'App/hooks/useEffect'
import useMutate from 'apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'
import useMessage from 'App/hooks/useMessage'

export default function View(props) {
  const mutate = useMutate()
  const showMessage = useMessage()
  const readMessages = async () => {
    try {
      await mutate({
        mutation: gql`
          mutation readConversation($conversationId: ID, $isAdmin: Boolean) {
            readConversation(conversationId: $conversationId, isAdmin: $isAdmin) {
              _id
              isUnreadByAdmin
              readByAdminAt
              readByVehicleAt
            }
          }
        `,
        variables: {
          conversationId: props.conversationId,
          isAdmin: true
        }
      })
    } catch (error) {
      showMessage(error)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      readMessages()
    }, 2000)

    return () => {
      clearInterval(interval)
    }
  }, [props.conversationId])

  return null
}
